import { render } from "./ProductSelectCollectionOrder.html?vue&type=template&id=c62a212c&scoped=true"
import script from "./ProductSelectCollectionOrder.js?vue&type=script&lang=js"
export * from "./ProductSelectCollectionOrder.js?vue&type=script&lang=js"

import "./ProductSelectCollectionOrder.css?vue&type=style&index=0&id=c62a212c&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c62a212c"]])

export default __exports__